import { DataProvider, Identifier, Record } from "react-admin";
import { REACT_APP_BACK_PATH } from "../../provider/auth/AuthProvider";

export const findOne = async (dataProvider: DataProvider, resource: string, filter: Object): Promise<any> => {
    console.log(filter)
    return await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 1 },
        filter: filter,
        sort: { field: "id", order: "ASC" }
    }).then((r) => {
        let d;
        if (r && r.data && r.data.length === 1) {
            d = r.data[0];
        }
        return d;
    });
};

export const getOne = async (dataProvider: DataProvider, resource: string, id: Identifier): Promise<any> => {
    return await dataProvider.getOne(resource, { id }).then((r) => {
        let d;
        if (r && r.data) {
            d = r.data;
        }
        return d;
    });
};

export const count = async (dataProvider: DataProvider, resource: string, filter: Object): Promise<number> => {
    return await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 1 },
        filter: filter,
        sort: { field: "id", order: "ASC" }
    }).then((r) => {
        let d = 0;
        if (r && r.total) {
            d = r.total;
        }
        return d;
    });
};

export const create = async (dataProvider: DataProvider, resource: string, data) => {
    return await dataProvider.create(resource, { data }).then(({ data }) => {
        return data;
    });
};

export const update = async (dataProvider: DataProvider, resource: string, id: Identifier, data, previousData?: Record) => {
    return await dataProvider.update(resource, { id, data, previousData }).then(({ data }) => {
        return data;
    });
};

export const findAndAction = async (dataProvider: DataProvider, resource: string, filter: Object, action: Function, currentPage = 1, perPage = 1000) => {
    let total;
    let data;
    await dataProvider.getList(resource, {
        pagination: { page: currentPage, perPage: perPage },
        filter,
        sort: { field: "id", order: "ASC" }
    }).then((r) => {
        total = r.total;
        data = r.data;
    });
    for (const d of data) {
        await action(d);
    }
    if (currentPage * perPage < total) {
        await findAndAction(dataProvider, resource, filter, action, (currentPage + 1), perPage)
    }
};


let actionId;

export const formAction = (form, notify, action) => async (e) => {
    clearTimeout(actionId);
    actionId = setTimeout(async () => {
        if (form.getState().invalid) {
            form.submit();
            notify('ra.message.invalid_form', { type: 'warning' });
        } else {
            await action();
        }
    }, 1000);
};

const defaultOptions: RequestInit = {
    headers: new Headers({
        'Content-Type': 'application/json; charset=UTF-8'
    }),
    mode: 'cors',
    credentials: 'include'
};

const doCall = async (url, params = {}, method = "GET") => {
    return fetch(new Request(`${REACT_APP_BACK_PATH}${url}`, {
        ...defaultOptions,
        body: JSON.stringify(params),
        method
    }));
};

export const doGet = async (url, params) => {
    return doCall(url, params);
};

export const doPost = async (url, params) => {
    return doCall(url, params, "POST");
};

export const sendMail = async (mail, params) => {
    return doPost(`/mail/${mail}`, params).catch((err) => {
        console.error("Impossible d'envoyer le mail", err);
    })
};
